export const CHANNEL_WORKSPACE_HEADER_ACTIONS = {
  main: [],
  email: [
    { type: "assessment", label: "View retention assessment" },
    { type: "report", key: "benchmark", label: "Store summary" },
    { type: "channel", channelId: "content-cal", label: "Content & creatives" },
  ],
  "paid-ads": [
    { type: "assessment", label: "Performance assessment" },
    { type: "report", key: "meta", label: "Full Meta ads report" },
    { type: "report", key: "target_audience", label: "Target audience" },
  ],
  "meta-ads": [
    { type: "assessment", label: "Performance assessment" },
    { type: "report", key: "meta", label: "Full Meta ads report" },
  ],
  "google-ads": [
    { type: "assessment", label: "Performance assessment" },
    { type: "report", key: "target_audience", label: "Target audience" },
  ],
  "tiktok-ads": [
    { type: "assessment", label: "Performance assessment" },
    { type: "report", key: "target_audience", label: "Target audience" },
  ],
  social: [
    { type: "assessment", label: "Content assessment" },
    { type: "report", key: "competitor", label: "Competitor analysis" },
    { type: "report", key: "target_audience", label: "Target audience" },
  ],
  "content-cal": [
    { type: "report", key: "yearlyContent", label: "Full events calendar" },
    { type: "channel", channelId: "social", label: "Content assessment" },
  ],
  seo: [
    { type: "assessment", label: "Visibility assessment" },
    { type: "report", key: "google_search_console", label: "GSC report" },
  ],
  pdp: [
    { type: "assessment", label: "Conversion assessment" },
    { type: "report", key: "conversion", label: "Conversion & PDP report" },
  ],
  google: [
    {
      type: "channel",
      channelId: "google",
      subchannelId: "google-search-console",
      label: "Google Search Console",
    },
    {
      type: "channel",
      channelId: "google",
      subchannelId: "google-merchant-center",
      label: "Google Merchant Center",
    },
  ],
  "google-search-console": [
    { type: "assessment", label: "Visibility assessment" },
    { type: "report", key: "google_search_console", label: "Full GSC report" },
  ],
  "google-merchant-center": [
    { type: "assessment", label: "Visibility assessment" },
    { type: "report", key: "google_merchant_center", label: "Full GMC report" },
  ],
};

export const getChannelWorkspaceHeaderActions = (contextId = "main") =>
  CHANNEL_WORKSPACE_HEADER_ACTIONS[contextId] ?? [];
